module.exports = __webpack_public_path__ + "static/media/exclamation-mark.97393b55.svg";